module.exports = __webpack_public_path__ + "static/img/emoji_7.cec2d306.png";